import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { Button, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { getTableData } from "../services";
import { triggerUnmappeQueryAtom } from "../atoms";
import { ActionTooltip } from "../../components/Tooltips";

const useStyles = makeStyles()((theme: Theme) => ({
  buttonFilter: {
    backgroundColor: theme.vars.palette.button.tonalBackground,
    border: `1px solid ${theme.vars.palette.filter.toggleBorder}`,
    fontSize: "0.875rem",
    height: "38px",
    padding: "4px 11px",

    "&.MuiButton-text.MuiButton-colorInherit": {
      color: theme.vars.palette.text.primary,
    },
    "&.MuiButton-colorPrimary": {
      backgroundColor: theme.vars.palette.filter.toggleSelectedBackground,
      color: theme.vars.palette.filter.toggleSelectedText,
    },
  },
}));

const useGetNbDuplicate = (api: string) => {
  const reloadAtom = useRecoilValue(triggerUnmappeQueryAtom);

  const query = useQuery(["is_duplicate", api, reloadAtom], () =>
    getTableData(api)
  );

  return query;
};

export const DuplicateFilter = ({
  config: { api },
  onClick,
  value,
}: {
  config: { api: string };
  onClick: (newValue: boolean | null) => void;
  value?: boolean | null;
}) => {
  const intl = useIntl();
  const { classes } = useStyles();
  const [active, setActive] = useState<boolean>(() => !!value);
  const duplicateQuery = useGetNbDuplicate(api);

  useEffect(() => {
    setActive(!!value);
  }, [value]);

  if (!duplicateQuery.isFetched || !duplicateQuery.data?.count) {
    return null;
  }

  return (
    <ActionTooltip
      title={intl.formatMessage({ id: "DUPLICATE_VALUES" })}
      translateTitle={false}
      rawChildren
    >
      <span>
        <Button
          className={classes.buttonFilter}
          color={active ? "primary" : "inherit"}
          onClick={() => {
            const next = !active;
            onClick(next ? true : null);
            setActive(next);
          }}
          startIcon={<WarningAmberIcon />}
          size="small"
        >
          {duplicateQuery.data?.count}
        </Button>
      </span>
    </ActionTooltip>
  );
};
